import { environment } from '../../../environments/environment';

export class App {

  static getPlacesNearByUrl() {
    return `${environment.server.base_url}/partner/places/`;
  }
}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/config/app.ts